









































































































import Vue from 'vue';
import {
  CloseFullscreenWrapper,
  CloseStepperWrapper,
  FormValidation,
  TriggerRefreshError,
  FileUpload,
} from '@/mixins';
import {
  FullscreenSuccess,
  FullscreenError,
  FullscreenLoading,
} from '@/components/fullscreen-wrapper-components';
import { required, maxLength } from 'vuelidate/lib/validators';
import { evaultCategoryKey } from '@/constants';
import { api, VAULT_API_SUB_URLS } from '@/api';
import InputMaskTypes from '@/directives/input-mask/input-mask-types';
import { req } from 'vuelidate/lib/validators/common';
import moment from 'moment';
import { dateFormat } from '@/constants';
import { ExtendMixins } from '@/services';
import { DocumentDetailFormModel, SelectOption } from '@/@types/member';

interface Data {
  showSubmitSuccessMessage: boolean;
  showErrorMessage: boolean;
  showSubmitErrorMessage: boolean;
  showEncryptedPDFError: boolean;
  showBadFileError: boolean;
  submitIsLoading: boolean;
  formModel: any;
}

export default ExtendMixins(
  CloseFullscreenWrapper,
  CloseStepperWrapper,
  FormValidation,
  TriggerRefreshError,
  FileUpload,
).extend({
  name: 'DocumentDetailForm',
  props: {
    editMode: {
      type: Boolean,
      default: false,
    },
    selectedDocument: {
      type: Object as () => any,
      default: null,
    },
    successMessage: {
      type: String,
      required: true,
    },
    errorMessage: {
      type: String,
      required: true,
    },
    errorEncryptedPDFMessage: {
      type: String,
      default: '',
    },
    errorBadFileMessage: {
      type: String,
      default: '',
    },
  },
  data(): Data {
    return {
      showSubmitSuccessMessage: false,
      showErrorMessage: false,
      showSubmitErrorMessage: false,
      showEncryptedPDFError: false,
      showBadFileError: false,
      submitIsLoading: false,
      formModel: {
        fileNickname: '',
        category: '',
        amount: '',
        noteToSelf: '',
      },
    };
  },
  beforeMount() {
    Object.assign(this.formModel, this.selectedDocument);
    this.constructShowErrorModel('formModel');
  },
  validations: {
    formModel: {
      fileNickname: {
        maxLength: maxLength(250),
      },
      category: {
        required,
      },
      amount: {
        required,
        maxValue(value): boolean {
          const val = InputMaskTypes.currency.deconstruct(value),
            valNum = parseFloat(val);
          return !req(value) || (!isNaN(valNum) && valNum <= 9999999999.99);
        },
      },
      noteToSelf: {
        maxLength: maxLength(256),
      },
    },
  },
  computed: {
    categoryOptions(): SelectOption[] {
      return Object.keys(evaultCategoryKey).map((key) => {
        return {
          value: parseInt(key),
          text: this.$options.filters.t(evaultCategoryKey[key]),
        };
      });
    },

    //      VALIDATIONS
    fileNicknameErrors(): string[] {
      const formField = 'formModel.fileNickname';
      return this.FormValidationMixin.constructErrors(formField, [
        this.FormValidationMixin.validateField(
          formField,
          'document-detail-form_form-error_nickname_length',
          'maxLength',
          { key: 'maxLength', val: 'max' },
        ),
      ]);
    },
    categoryErrors(): string[] {
      const formField = 'formModel.category';
      return this.FormValidationMixin.constructErrors(formField, [
        this.FormValidationMixin.validateField(
          formField,
          [
            'document-detail-form_form-error_category_required',
            'global_form-error_default_required',
          ],
          'required',
        ),
      ]);
    },
    amountErrors(): string[] {
      const formField = 'formModel.amount';
      return this.FormValidationMixin.constructErrors(formField, [
        this.FormValidationMixin.validateField(
          formField,
          [
            'document-detail-form_form-error_amount_required',
            'global_form-error_default_required',
          ],
          'required',
        ),
        this.FormValidationMixin.validateField(
          formField,
          'document-detail-form_form-error_amount_max-value',
          'maxValue',
        ),
      ]);
    },
    noteToSelfErrors(): string[] {
      const formField = 'formModel.noteToSelf';
      return this.FormValidationMixin.constructErrors(formField, [
        this.FormValidationMixin.validateField(
          formField,
          'document-detail-form_form-error_note-to-self_length',
          'maxLength',
          { key: 'maxLength', val: 'max' },
        ),
      ]);
    },
  },
  methods: {
    tryAgain(): void {
      this.clearErrorMessages();
      // @ts-ignore();
      this.confirmBeforeClose = true;
      this.$emit('updateConfirmBeforeClose', true);
      this.submitForm();
    },
    doneAction(): void {
      if (this.editMode) {
        this.closeFullscreenWrapper();
      } else {
        this.closeStepperWrapper();
      }
    },
    submitForm(): void {
      if (this.editMode) {
        this.updateDocumentDetail();
      } else {
        this.uploadFile();
      }
    },
    toggleLoading(val): void {
      this.submitIsLoading = val;
      this.$emit('isLoading', val);
    },
    category(): number {
      let category;
      switch (this.formModel.category) {
        case 'Medical':
          category = 1;
          break;
        case 'Drug':
          category = 2;
          break;
        case 'Dental':
          category = 3;
          break;
        case 'Day Care':
          category = 4;
          break;
        case 'Premium':
          category = 5;
          break;
        case 'Transportation':
          category = 6;
          break;
        case 'Other':
          category = 7;
          break;
        case 'Non-Claim Document':
          category = 8;
          break;
        default:
          category = '';

          return category;
      }
    },
    uploadFile(): void {
      this.toggleLoading(true);
      const uploadDate = moment().format(dateFormat);
      const files = [this.selectedDocument.file] as any;
      const payload = Object.assign({}, this.formModel, {
        startDate: null,
        endDate: null,
        onlineClaimKey: null,
      });
      delete payload[files];
      this.uploadFiles(files)
        .then((fileIds) => {
          const BODY = [{
            vaultId: null,
            matchId: null,
            onlineClaimId: null,
            category: this.formModel.category,
            imageId: fileIds[this.formModel.fileName],
            fileName: this.formModel.fileName,
            fileNickname: this.formModel.fileNickname,
            uploadDate,
            amount: this.formModel.amount.toString(),
            isSubmitted: null,
            isMatched: null,
            noteToSelf: this.formModel.noteToSelf,
            fromDate: null,
            toDate: null,
            patientName: null,
            providerName: null,
            iCaseId: null,
            iCaseLineId: null,
          }];
          api
            .post(
              `${VAULT_API_SUB_URLS.members}/${this.$store.getters.memberId}/vault-data`,
              BODY,
            )
            .then(() => {
              this.showSuccess();

              // Trigger Analytics
              window.dataLayer.push({
                event: 'uploadFile',
              });
            })
            .catch(() => {
              this.showError();
              this.$emit('doneLoading');
            });
        })
        .catch((error) => {
          this.showError();
          this.$emit('doneLoading');
        });
    },
    updateDocumentDetail(): void {
      this.toggleLoading(true);
      const BODY = {
            vaultId: this.formModel.vaultId,
            matchId: null,
            onlineClaimId: null,
            category: this.formModel.category,
            fileNickname: this.formModel.fileNickname,
            uploadDate: this.formModel.uploadDate,
            amount: this.formModel.amount,
            isSubmitted: this.formModel.isSubmitted ? this.formModel.isSubmitted : null,
            isMatched: this.formModel.isMatched ? this.formModel.isSubmitted : null,
            noteToSelf: this.formModel.noteToSelf,
            fromDate: this.formModel.fromDate,
            toDate: this.formModel.toDate,
            patientName: this.formModel.patientName,
            providerName: this.formModel.providerName,
            iCaseId: null,
            iCaseLineId: null,
      };
      api
        .patch(
          `${VAULT_API_SUB_URLS.vaultData}/${this.formModel.vaultId}`,
          BODY,
        )
        .then(() => {
          this.refreshEvaultData();
        })
        .catch(() => {
          this.showError();
          this.$emit('doneLoading');
        });
    },
    refreshEvaultData(): void {
      this.$store
        .dispatch('getVaultData')
        .then(() => {
          this.showSuccess();
        })
        .catch(() => {
          this.triggerRefreshError({
            message: [
              'document-detail-form_text_refresh-data-error-message',
              'global_connection-error',
            ],
          });
          this.$emit('updateConfirmBeforeClose', false);
        });
    },
    showSuccess(): void {
      // @ts-ignore
      this.confirmBeforeClose = false;
      this.$emit('updateConfirmBeforeClose', false);
      this.showSubmitSuccessMessage = true;
      this.clearErrorMessages();
      this.toggleLoading(false);
      this.$emit('doneLoading');
    },
    clearErrorMessages(): void {
      this.showErrorMessage = false;
      this.showSubmitErrorMessage = false;
      this.showEncryptedPDFError = false;
      this.showBadFileError = false;
    },
    showError(): void {
      // @ts-ignore
      this.confirmBeforeClose = false;
      this.$emit('updateConfirmBeforeClose', false);
      this.showErrorMessage = true;
      this.showSubmitSuccessMessage = false;
      this.showSubmitErrorMessage = true;
      this.toggleLoading(false);
    },
  },
  components: {
    FullscreenSuccess,
    FullscreenError,
    FullscreenLoading,
  },
});
